var map = {
	"./af.json": "bGli",
	"./am.json": "DAjH",
	"./ar.json": "YaKH",
	"./bg.json": "HX41",
	"./ca.json": "wlVK",
	"./cs.json": "qPN8",
	"./da.json": "vbN5",
	"./de.json": "lO4q",
	"./el.json": "dY4e",
	"./en.json": "1eHR",
	"./es.json": "LJsq",
	"./et.json": "lSWN",
	"./fi.json": "Rve+",
	"./fil.json": "vq8r",
	"./fr.json": "l4j5",
	"./he.json": "+Isv",
	"./hi.json": "586N",
	"./hr.json": "Rvkr",
	"./hu.json": "fPEC",
	"./id.json": "bHCM",
	"./it.json": "MKDG",
	"./ja.json": "PjOe",
	"./ko.json": "wYPT",
	"./lt.json": "afCv",
	"./lv.json": "wApW",
	"./ms.json": "kzbq",
	"./nb.json": "LnOP",
	"./nl.json": "gW4w",
	"./no.json": "8Tp7",
	"./pl.json": "x0GM",
	"./pt.json": "XoUl",
	"./ro.json": "RELm",
	"./ru.json": "wRvd",
	"./sk.json": "myV1",
	"./sl.json": "agkP",
	"./sr.json": "Blzj",
	"./sv.json": "ndcH",
	"./sw.json": "q0se",
	"./th.json": "zU+0",
	"./tr.json": "yhYt",
	"./uk.json": "giSZ",
	"./vi.json": "LqR0",
	"./zh.json": "v2x6",
	"./zu.json": "rVm5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cW82";